// Thin shim that re-exports the official r180 addons DRACOLoader.
// Used by GLTFLoader to decode KHR_draco_mesh_compression compressed glb/gltf.
// See libs/three.js/examples/jsm/loaders/DRACOLoader.js for the actual implementation.
export { DRACOLoader } from '../../libs/three.js/examples/jsm/loaders/DRACOLoader.js';
